import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  BoardListParams,
  FetchBoardDetailParams,
  FetchFaqParams,
  FetchInquireListParams,
} from '@module/apis/client-side/customer/type';

export const customerQueryKeys = createQueryKeys('customer', {
  fetchFaq: (params: FetchFaqParams) => [params],
  fetchBoardList: (params: BoardListParams) => [params],
  fetchBoardDetail: (params: FetchBoardDetailParams) => [params],
  fetchInquireList: (params: FetchInquireListParams) => [params],
  fetchInquireWrite: () => ['inquireWrite'],
  fetchInquireDelete: () => ['inquireDelete'],
  fetchInquireModify: () => ['inquireModify'],
});
